import React from 'react';

const PanelText = ({ title, description }) => {
  const panelTextStyle = {
    width: '22vw',
    padding: '0 40px 0 65px',
    whiteSpace: 'normal'
  };
  return (
    <li className="h-100p d-if flex-col justify-content-c va-t" style={panelTextStyle}>
      <p className="ff-qsm fz-18 c-b1b0b0 tt-l">{title}</p>
      <div className="pt-25 ff-qsl fz-13 lh-1pt4 c-b1b0b0">
        {description.split('\n').map(i => {
          return (
            <p className="mb-10" key={i}>
              {i}
            </p>
          );
        })}
      </div>
    </li>
  );
};

export default PanelText;



// WEBPACK FOOTER //
// ./src/components/panel_text.js